import * as React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';

// Replaces the native `title` tooltip: <Tip content="Edit"><button …/></Tip>.
// Renders the child untouched when there's nothing to say, so conditional
// tooltips (e.g. only while the sidebar is collapsed) stay cheap.
const Tip = ({ content, side = 'top', align = 'center', delay, children }) => {
    if (content === undefined || content === null || content === '' || content === false) return children;
    return (
        <Tooltip delayDuration={delay}>
            <TooltipTrigger asChild>{children}</TooltipTrigger>
            <TooltipContent side={side} align={align}>{content}</TooltipContent>
        </Tooltip>
    );
};

export default Tip;
